import { mount } from "@vue/test-utils";
import TopBar from "@/components/core/TopBar";

jest.mock("@/components/core/TopBar", () => ({
  ...jest.requireActual("@/components/core/TopBar"),
  methods: {
    watch: jest.fn()
  }
}));

describe("TopBar test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(TopBar);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component TopBar", () => {
    expect(wrapper).toBeDefined();
  });
});
